import React from 'react'
import { useDraggableSheet } from '../../../helpers/hooks';
import Icon from '../Icon/Icon';

function OverlayNotification({ onClose,email }) {
    const { sheetStyle, overlayHandlers } = useDraggableSheet({ onClose });
// i kept the below func just in case i had to reuse this component (it was created before but this component was unused and wasn't completed)
    

// const getIconConfig = (type) => {
    //     switch (type) {
    //         case 'shipment':
    //             return {
    //                 alias: 'shipment',
    //                 containerBg: '#FF8CDC',
    //                 iconColor: '#FFFFFF'
    //             };
    //         case 'success':
    //             return {
    //                 alias: 'check_circle',
    //                 containerBg: '#3BB273',
    //                 iconColor: '#FFFFFF'
    //             };
    //         case 'error':
    //             return {
    //                 alias: 'error',
    //                 containerBg: '#FF3232',
    //                 iconColor: '#FFFFFF'
    //             };
    //         case 'notification':
    //             return {
    //                 alias: 'bell',
    //                 containerBg: '#4EB9E8',
    //                 iconColor: '#FFFFFF'
    //             };
    //         default:
    //             return {
    //                 alias: 'info',
    //                 containerBg: '#4EB9E8',
    //                 iconColor: '#FFFFFF'
    //             };
    //     }
    // };
    //const iconConfig = getIconConfig();
    return (
        <div className="update-order">
            <div className="overlay" {...overlayHandlers}></div>
            <div className="sheet py-24 d-flex d-row aic jcc acc" style={sheetStyle} onClick={(e) => e.stopPropagation()}>
                <Icon alias={"check-your-email"} height={200} width={200} />
                <div className='d-flex f-column aic jcc'>
                    <p className='mt-32 fs-sm2 fw-bold fg-dark' >Verify your identity to withdraw</p>

                    <p className='mt-10 fs-regular fw-medium fg-dark' >We sent an email to {email}</p>
                    <p className='mt-10 fs-regular fw-medium fg-dark' >open it and click on the link to complete KYC</p>
                    <button
                            onClick={onClose}
                           
                            className="btn red-outline-btn mt-48 py-24 d-flex aic jcc w-full"
                        >
                            Cancel
                        </button>
                </div>


            </div>
        </div>
    )
}

export default OverlayNotification